import React from 'react';

// import { Container } from './styles';

export default function cart() {
  return (
    <div className="container mt-5">
        <div className="row">
            <div className="col-10 mx-auto text-center text-title">
                <h1>Seu Carrinho está Vázio</h1>
            </div>

        </div>
    </div>
  );
}
